<template lang="pug">
  div(class="organization-exists-dialog")
    div(class="organization-exists-dialog__icon")
      v-img(
        :src="require('~/assets/images/warning-gray-box.png')"
        :max-width="xsDevice ? 56 : 80"
      )
    h2(
      class="mb-2"
      :class="[xsDevice ? 'title-20px medium' : 'title-32px bold']"
    ) {{ $t('Organization already exists') }}
    p(class="text-14px light mb-4") {{ $t('This organization was created by another account') }}
    div(class="organization-exists-dialog__info mb-6")
      div(class="info-row")
        span(class="text-14px medium gray") {{ $t('Organization') }}:
        span(class="text-14px medium") {{ organizationName }}
      div(class="info-row")
        span(class="text-14px medium gray") {{ $t('EDRPOU') }}:
        span(class="text-14px medium") {{ edrpou }}
      div(class="info-row")
        span(class="text-14px medium gray") {{ $t('Owner email') }}:
        span(class="text-14px medium") {{ ownerEmail }}
    p(class="text-14px light mb-4") {{ $t('You can send a request to join this organization') }}.

    ValidationObserver(ref="form")
      ValidationProvider(
        :name="$t('Role')"
        rules="required"
        v-slot="{ errors }"
      )
        v-select(
          v-model="selectedRole"
          :items="availableRoles"
          :label="$t('Select your role in organization')"
          :error-messages="errors"
          item-text="text"
          item-value="value"
          filled
          class="mb-4"
        )

    div(class="organization-exists-dialog__actions")
      v-btn(
        @click="closeModal(false)"
        class="secondary-button"
        height="48"
        :class="{ 'w-100 mb-2': xsDevice }"
      ) {{ $t('Cancel') }}
      v-btn(
        @click="sendJoinRequest"
        :loading="loading"
        :disabled="!selectedRole"
        class="main-button"
        height="48"
        :class="{ 'w-100': xsDevice }"
      ) {{ $t('Send request to owner') }}
</template>

<script>
import OrganizationUsers from '~/modules/organizations/models/OrganizationUsers'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'MOrganizationExistsDialog',
  mixins: [responsive],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    organizationId: {
      type: String,
      required: true
    },
    organizationName: {
      type: String,
      required: true
    },
    edrpou: {
      type: String,
      required: true
    },
    ownerEmail: {
      type: String,
      required: true
    },
    edrpouSigned: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedRole: null,
      loading: false
    }
  },
  computed: {
    availableRoles() {
      return OrganizationUsers.userRoles.filter(
        role => role.value !== OrganizationUsers.ROLES.OWNER
      )
    }
  },
  methods: {
    async sendJoinRequest() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      try {
        this.loading = true
        await this.$store.dispatch('organizations/joinOrganization', {
          organizationId: this.organizationId,
          payload: {
            role: this.selectedRole,
            signature: this.edrpouSigned
          }
        })
        this.$notification.success(
          this.$t('Your join request has been sent successfully')
        )
        this.closeModal(true)
      } catch (e) {
        this.$handlers.error(e, this)
        this.closeModal(false)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.organization-exists-dialog {
  &__icon {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }
  &__info {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 16px;
    .info-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      .gray {
        color: #757575;
      }
    }
  }
  &__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    @media (max-width: map-get($breakpoints, 'sm')) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
